import { axiosAuthInstance } from '../main.js'

export default {
  methods: {
    fetchAvailableLenders(exclusiveBankId) {
      var url = 'api/v1/lender/program/' + this.$store.getters.getProgram.id;
      if (exclusiveBankId) {
        url += '/'+exclusiveBankId
      }

      return axiosAuthInstance.get(url)
      .then(response => {
        this.$store.commit('setAvailableLenders', response.data)
      })
      .catch(error => {
        console.log('error response: ' + error)
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/axiosMethods.js